import { useState, useCallback } from 'react';

/* eslint-disable react-hooks/exhaustive-deps */
var useFlowBuilderSession = function () {
    var platformStoreId = sessionStorage.getItem("platformStoreId");
    var sessionKey = useState("fbq_navigation_".concat(platformStoreId || ""))[0];
    if (!platformStoreId) {
        var queryParams = new URLSearchParams(window.location.search);
        platformStoreId = queryParams === null || queryParams === void 0 ? void 0 : queryParams.get("shop");
        if (platformStoreId) {
            sessionStorage.setItem("platformStoreId", platformStoreId);
        }
        else {
            throw new Error("'platformStoreId' not found in session storage");
        }
    }
    var readNavigationObj = useCallback(function () { return JSON.parse(sessionStorage.getItem(sessionKey) || "{}") || {}; }, [sessionKey]);
    var navigation = useCallback(function (path) {
        var navigation = readNavigationObj();
        return navigation[path];
    }, []);
    var updateNavigation = useCallback(function (path, value) {
        var navigation = readNavigationObj();
        navigation[path] = value;
        sessionStorage.setItem(sessionKey, JSON.stringify(navigation));
    }, [sessionKey]);
    var clearNavigation = useCallback(function () { return sessionStorage.removeItem(sessionKey); }, [sessionKey]);
    var getRedirectUrl = useCallback(function () { return navigation("redirectUrl"); }, []);
    var setRedirectUrl = useCallback(function (value) {
        updateNavigation("redirectUrl", value);
    }, []);
    var getPage = useCallback(function () { return navigation("currentPage"); }, []);
    var setPage = useCallback(function (value) {
        if (getPage() === value)
            return;
        updateNavigation("selectedVariant", null);
        updateNavigation("selectedCondition", null);
        updateNavigation("currentPage", value);
    }, []);
    var getSelectedCondition = useCallback(function () { return navigation("selectedCondition"); }, []);
    var setSelectedCondition = useCallback(function (value) {
        if (getSelectedCondition() === value)
            return;
        updateNavigation("selectedVariant", null);
        updateNavigation("selectedCondition", value);
    }, []);
    var getSelectedVariant = useCallback(function () { return navigation("selectedVariant"); }, []);
    var setSelectedVariant = useCallback(function (value) {
        updateNavigation("selectedVariant", value);
    }, []);
    var getFlowBuilderUrl = useCallback(function () { return navigation("flowBuilderUrl"); }, []);
    var setFlowBuilderUrl = useCallback(function (value) {
        updateNavigation("flowBuilderUrl", value);
    }, []);
    var getFlowEditorUrl = useCallback(function () { return navigation("flowEditorUrl"); }, []);
    var setFlowEditorUrl = useCallback(function (value) {
        updateNavigation("flowEditorUrl", value);
    }, []);
    var getBreadcrumb = useCallback(function () { return navigation("breadcrumb"); }, []);
    var setBreadcrumb = useCallback(function (value) {
        updateNavigation("breadcrumb", value);
    }, []);
    var getChatbotUrl = useCallback(function () { return navigation("chatbotUrl"); }, []);
    var setChatbotUrl = useCallback(function (value) {
        updateNavigation("chatbotUrl", value);
    }, []);
    var setCanCreateSlot = useCallback(function (value) {
        updateNavigation("canCreateSlot", value);
    }, []);
    var removeCanCreateSlot = useCallback(function () {
        updateNavigation("canCreateSlot", null);
    }, []);
    var getCanCreateSlot = useCallback(function () { return navigation("canCreateSlot"); }, []);
    var getIsChatBotOpen = useCallback(function () { return navigation("isChatBotOpen"); }, []);
    var setIsChatBotOpen = useCallback(function (value) {
        updateNavigation("isChatBotOpen", value);
    }, []);
    var getChatBotSessionID = useCallback(function () { return navigation("chatBotSessionID"); }, []);
    var setChatBotSessionID = useCallback(function (value) {
        updateNavigation("chatBotSessionID", value);
    }, []);
    var setFormEditorUrl = useCallback(function (value) {
        if (platformStoreId) {
            updateNavigation("formEditorUrl", value);
        }
    }, [platformStoreId]);
    var getFormEditorUrl = useCallback(function () {
        if (platformStoreId) {
            return navigation("formEditorUrl");
        }
        return null;
    }, [platformStoreId]);
    var removeFormEditorUrl = useCallback(function () {
        if (platformStoreId) {
            updateNavigation("formEditorUrl", null);
        }
    }, [platformStoreId]);
    return {
        getRedirectUrlFromSession: getRedirectUrl,
        getPageFromSession: getPage,
        getSelectedConditionFromSession: getSelectedCondition,
        getSelectedVariantFromSession: getSelectedVariant,
        getFlowBuilderUrlFromSession: getFlowBuilderUrl,
        getFlowEditorUrlFromSession: getFlowEditorUrl,
        getBreadcrumbFromSession: getBreadcrumb,
        getChatbotUrlFromSession: getChatbotUrl,
        setRedirectUrlInSession: setRedirectUrl,
        setPageInSession: setPage,
        setSelectedConditionInSession: setSelectedCondition,
        setSelectedVariantInSession: setSelectedVariant,
        setFlowBuilderUrlInSession: setFlowBuilderUrl,
        setFlowEditorUrlInSession: setFlowEditorUrl,
        setBreadcrumbInSession: setBreadcrumb,
        setChatbotUrlInSession: setChatbotUrl,
        setCanCreateSlotInSession: setCanCreateSlot,
        getCanCreateSlotFromSession: getCanCreateSlot,
        removeCanCreateSlotInSession: removeCanCreateSlot,
        clearNavigationInSession: clearNavigation,
        getIsChatBotOpenFromSession: getIsChatBotOpen,
        setIsChatBotOpenInSession: setIsChatBotOpen,
        getChatBotSessionIDFromSession: getChatBotSessionID,
        setChatBotSessionIDInSession: setChatBotSessionID,
        setFormEditorUrlInSession: setFormEditorUrl,
        getFormEditorUrlFromSession: getFormEditorUrl,
        removeFormEditorUrlInSession: removeFormEditorUrl,
    };
};

export { useFlowBuilderSession };
//# sourceMappingURL=useFlowBuilderSession.js.map
